import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, Entity, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { Personal } from "../Personal";
import { PersonalTiendas } from "./PersonalTiendas";

export const ACTAsignarPersonal: EntityClientAction = {
    name: 'ACTSeleccionarTiendas',
    label: 'Asignar Personal',
    title: <Text fw={700}>Asignar personal a tiendas seleccionadas</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        // cast entity
        const parent = entity as PersonalTiendas;
        const personal = new Personal(entity.API.client);

        if (modal) {
            await modal.open({
                modalProps: {
                    title: <Text fw="700">Asignar personal a tiendas seleccionadas</Text>,
                    size: 'xl'
                },
                focusOnClosed: element,
                content: <LookupFormAction
                    lookupEntity={personal}
                    viewName={personal.def.views.perl_brwJefes.name}
                    title="Asignar personal a tiendas seleccionadas"
                    onActionFinished={onClose}
                    onOK={
                        async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                            const personal_tiendas = Entity.clone(parent) as PersonalTiendas;

                            const result: DBStatusResult = { Failed: false, AutonumReturned: false, Results: [] };

                            for (const key of selectedKeys ?? []) {
                                personal_tiendas.def.columns.c_tienda_id.value = key[personal_tiendas.def.columns.c_tienda_id.name] as string;
                                const ret = await personal_tiendas.API.addData(abortSignal, keys, true);
                                if (ret.Failed) {
                                    result.Failed = true;
                                    result.Results.push(...ret.Results);
                                }
                            }

                            return result;
                        }
                    }


                />

            });
        }
        else {
            console.log('modal context not found');
            return Promise.resolve();
        }


    }

}

